/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const MaterialQueryKeys = {
  all: ['user'] as const,
  lists: () => [...MaterialQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...MaterialQueryKeys.lists(), { filters }] as const,
  details: () => [...MaterialQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...MaterialQueryKeys.details(), id] as const,
};
